const plans = {
  free: {
    name: 'Free',
    description: 'Improve Every Week with Free Training!',
    options: [
      {
        list: [
          [
            {
              title: '20 Interactive Hand Quizzes',
              checked: true,
            },
            {
              title: '10 Coaching Classes',
              checked: true,
            },
            {
              title: '70+ Poker Courses',
              checked: false,
            },
            {
              title: '13 Poker Series',
              checked: false,
            },
          ],
          [
            {
              title: 'Free Training Every Week',
              checked: true,
            },
            {
              title: 'New Coaching Classes Every Week',
              checked: false,
            },
            {
              title: 'Live Weekly Coaching',
              checked: false,
            },
          ],
          [
            {
              title: 'Master the Fundamentals',
              checked: true,
            },
            {
              title: 'Cash Game Masterclass',
              checked: false,
            },
            {
              title: 'Tournament Masterclass',
              checked: false,
            },
            {
              title: '13-Day Cash Game Challenge',
              checked: false,
            },
            {
              title: '30-Day Tournament Challenge',
              checked: false,
            },
          ],
        ],
      },
      {
        title: 'GTO preflop charts',
        list: [
          [
            {
              title: 'Cash Games 8MAX: 100, 150, 200 bbs',
              checked: true,
            },
            {
              title: 'Tournament: 20 bbs',
              checked: true,
            },
            {
              title: 'Tournament: 10, 12, 15, 25 bbs',
              checked: false,
            },
            {
              title: 'Tournament: 30, 40, 60, 80 bbs',
              checked: false,
            },
            {
              title: 'ICM - Small Ante',
              checked: false,
            },
            {
              title: 'ICM - 1 bb Ante',
              checked: false,
            },
            {
              title: 'HU MTT - Small Ante',
              checked: false,
            },
            {
              title: 'HU MTT - 1 bb ante',
              checked: false,
            },
          ],
        ],
      },
      {
        list: [
          [
            {
              title: '12,500+ Member Discord Server',
              checked: true,
            },
          ],
        ],
      },
    ],
    badge: '',
    save: '',
    priceMonth: '',
    priceYear: '',
    payInfo: 'No credit card required. Free for life.',
    startButtonText: 'Get started',
    startButtonLink: '/register/ref/[ref]/?lp=from_home&campaign=[campaign]',
    buyLink: '',
  },
  standard: {
    name: 'Standard',
    description: 'Improve Every Day with Interactive Hand Quizzes!',
    options: [
      {
        list: [
          [
            {
              title: '1,800+ Interactive Hand Quizzes',
              checked: true,
            },
            {
              title: '700+ Coaching Classes',
              checked: false,
            },
            {
              title: '70+ Poker Courses',
              checked: false,
            },
            {
              title: '13 Poker Series',
              checked: false,
            },
          ],
          [
            {
              title: 'New Hand Quizzes Every Week',
              checked: true,
            },
            {
              title: 'New Coaching Classes Every Week',
              checked: false,
            },
            {
              title: 'Live Weekly Coaching',
              checked: false,
            },
          ],
          [
            {
              title: 'Master the Fundamentals',
              checked: true,
            },
            {
              title: 'Cash Game Masterclasss',
              checked: false,
            },
            {
              title: 'Tournament Masterclass',
              checked: false,
            },
            {
              title: '13-Day Cash Game Challenge',
              checked: false,
            },
            {
              title: '30-Day Tournament Challenge',
              checked: false,
            },
          ],
        ],
      },
      {
        title: 'GTO preflop charts',
        list: [
          [
            {
              title: 'Cash Games 8MAX: 100, 150, 200 bbs',
              checked: true,
            },
            {
              title: 'Tournament: 20 bbs',
              checked: true,
            },
            {
              title: 'Tournament: 10, 12, 15, 25 bbs',
              checked: true,
            },
            {
              title: 'Tournament: 30, 40, 60, 80 bbs',
              checked: true,
            },
            {
              title: 'ICM - Small Ante',
              checked: true,
            },
            {
              title: 'ICM - 1 bb Ante',
              checked: true,
            },
            {
              title: 'HU MTT - Small Ante',
              checked: true,
            },
            {
              title: 'HU MTT - 1bb Ante',
              checked: true,
            },
          ],
        ],
      },
      {
        list: [
          [
            {
              title: '12,500+ Member Discord Server',
              checked: true,
            },
          ],
        ],
      },
    ],
    badge: 'Best value',
    save: 'Save 20%',
    priceMonth: '$49',
    priceYear: '$39',
    payInfo: {
      monthly: 'Billed monthly. Cancel anytime.',
      yearly: 'Billed annually (Save $240/year)',
    },
    startButtonText: {
      monthly: 'Get Started',
      yearly: 'Get Started',
    },
    startButtonLink: {
      monthly: '/cart/?add-to-cart=1442388',
      yearly: '/coupons/StandardF39',
    },
    buyLink: {
      monthly: '/cart/?add-to-cart=19800',
      yearly: '/coupons/Standard39',
    },
  },
  premium: {
    name: 'Premium',
    description: 'Learn from Pros with $75 Million in Earnings!',
    options: [
      {
        list: [
          [
            {
              title: '1,800+ Interactive Hand Quizzes',
              checked: true,
            },
            {
              title: '700+ Coaching Classes',
              checked: true,
            },
            {
              title: '70+ Poker Courses',
              checked: true,
            },
            {
              title: '13 Poker Series',
              checked: true,
            },
          ],
          [
            {
              title: 'New Hand Quizzes Every Week',
              checked: true,
            },
            {
              title: 'New Coaching Classes Every Week',
              checked: true,
            },
            {
              title: 'Live Weekly Coaching',
              checked: true,
            },
          ],
          [
            {
              title: 'Master the Fundamentals',
              checked: true,
            },
            {
              title: 'Cash Game Masterclass',
              checked: true,
            },
            {
              title: 'Tournament Masterclass',
              checked: true,
            },
            {
              title: '13-Day Cash Game Challenge',
              checked: true,
            },
            {
              title: '30-Day Tournament Challenge',
              checked: true,
            },
          ],
        ],
      },
      {
        title: 'GTO preflop charts',
        list: [
          [
            {
              title: 'Cash Games 8MAX: 100, 150, 200 bbs',
              checked: true,
            },
            {
              title: 'Tournament: 20 bbs',
              checked: true,
            },
            {
              title: 'Tournament: 10, 12, 15, 25 bbs',
              checked: true,
            },
            {
              title: 'Tournament: 30, 40, 60, 80 bbs',
              checked: true,
            },
            {
              title: 'ICM - Small Ante',
              checked: true,
            },
            {
              title: 'ICM - 1 bb Ante',
              checked: true,
            },
            {
              title: 'HU MTT - Small Ante',
              checked: true,
            },
            {
              title: 'HU MTT - 1bb Ante',
              checked: true,
            },
          ],
        ],
      },
      {
        list: [
          [
            {
              title: '12,500+ Member Discord Server',
              checked: true,
            },
          ],
        ],
      },
    ],
    badge: 'Best value',
    save: 'Save 20%',
    priceMonth: '$147',
    priceYear: '$118',
    payInfo: {
      monthly: 'Billed monthly. Cancel anytime.',
      yearly: 'Billed annually (Save $348/year)',
    },
    startButtonText: {
      monthly: 'GET STARTED',
      yearly: 'GET STARTED',
    },
    startButtonLink: {
      monthly: '/cart/?add-to-cart=2043959',
      yearly: '/coupons/PREMIUMF79',
    },
    buyLink: {
      monthly: '/cart/?add-to-cart=19815',
      yearly: '/coupons/PREMIUM79',
    },
  },
};

export default plans;